import React from 'react';

import { flagStyles } from '../settings';

const SvgMY = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-3744px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgMY;
